export const zeroCostCopy =
  'This project boundary edit is free since this is a minor edit, or below the unit size for this project type.';
